import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

const base = (preProjectId) => `${Config.api.tender.url}pre-projects/${preProjectId}/sources`;

class PreProjectSourcesService {
  list(preProjectId) {
    return ApiService.get(base(preProjectId)).then((response) => response.data);
  }

  createLink(preProjectId, { title, url }) {
    return ApiService.post(base(preProjectId), { title, url }).then((response) => response.data);
  }

  uploadDocument(preProjectId, { file, title = null }) {
    const formData = new FormData();
    formData.append('file', file);
    if (title) formData.append('title', title);
    return ApiService.post(`${base(preProjectId)}/document`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((response) => response.data);
  }

  getDownloadUrl(preProjectId, sourceId) {
    return ApiService.get(`${base(preProjectId)}/${sourceId}/download`).then((response) => response.data.url);
  }

  remove(preProjectId, sourceId) {
    return ApiService.delete(`${base(preProjectId)}/${sourceId}`).then((response) => response.data);
  }
}

export const preProjectSourcesService = new PreProjectSourcesService();
